<div class="courrier-releve-container">
  <div class="filter-title">
      <h3>Filtres</h3>
  </div>
  <div class="filters">
    <form *ngIf="formFilter" [formGroup]="formFilter" (ngSubmit)="onSubmitRecherche()">
      <div class="filter-input-container">
        <div class="filter-input-row">
          <frg-form-input type="text" label="Patient" placeholder="Nom du patient" id="patient" [formGroup]="formFilter" [control]="formFilter.get('patient')"></frg-form-input>
          <frg-form-input type="ngSelect" label="Validation INSI" id="validationInsi" [formGroup]="formFilter" [control]="formFilter.get('validationInsi')" [selectValue]="validationInsi"></frg-form-input>
        </div>
        <div class="filter-input-row">
          <frg-form-input type="text" label="Document" placeholder="Nom du document" id="document" [formGroup]="formFilter" [control]="formFilter.get('document')"></frg-form-input>
          <frg-form-input type="date" label="Date de réception" placeholder="JJ/MM/AAAA" id="date" [formGroup]="formFilter" [control]="formFilter.get('date')"></frg-form-input>
          <frg-form-input *ngIf="typeDocuments" type="ngSelect" label="Type du document" id="typeDocument" [formGroup]="formFilter" [control]="formFilter.get('typeDocument')" [selectValue]="typeDocuments"></frg-form-input>
        </div>
      </div>
      <frg-button [type]="'submit'" [backgroundColor]="'var(--primary)'">Rechercher</frg-button>
    </form>
  </div>
    <!-- Bouton avec un tooltip -->

    <div class="buttonContainer">
      <button class="button-tooltip" (mouseenter)="showTooltip()" (mouseleave)="hideTooltip()">
        <mat-icon>info</mat-icon>
      </button>
      <frg-button (activated)="lancerTraitement()">
        Traiter les messages
      </frg-button>
    </div>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" multiTemplateDataRows matSort (matSortChange)="onMatSortChange($event)">
      <!-- De Column -->
      <ng-container matColumnDef="patient-status">
        <th mat-header-cell class="patient-status" *matHeaderCellDef></th>
        <td mat-cell class="patient-status" *matCellDef="let message">
          <div
            class="status-fragment"
            [class.selected]="message.patient"
            [class.selected-status-inconnu]="!message.patient && !message.patientIdentiteRecuperee && !message.patientIdentiteValidee && !message.patientIdentiteProvisoire"
            [class.selected-status-valide]="message.patientInfosStatusValide"
            [class.selected-status-recupere]="message.patientInfosStatusRecupere"
            [class.selected-status-provisoire]="message.patientInfosStatusProvisoire"
          ></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="ins-status">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell class="ins-status" *matCellDef="let message">
          <div
            class="status-fragment"
            [class.ins-ok]="message.infoPatientDocument && message.infoPatientDocument.isInsOk"
            [class.ins-ko]="message.infoPatientDocument && !message.infoPatientDocument.isInsOk"
          ></div>
        </td>
      </ng-container>

      <!-- De Column -->
      <ng-container matColumnDef="from">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> De </th>
        <td mat-cell *matCellDef="let message" class="from" [class.hors-domaine-confiance]="!message.isDomaineConfiance">
          <span *ngIf="message.from && (message.from.includes('@medecin.mssante.fr') || message.from.includes('@medecin.formation.mssante.fr'))" 
                class="icon-sender icon-consultation"
                title="Professionnel de santé"></span>
          <span *ngIf="message.from && message.from.includes('@patient.mssante.fr')" 
                class="icon-sender icon-patient"
                title="Patient (Mon espace santé)"></span>
          <span style="vertical-align: middle;">{{message.from}}</span>
        </td>
      </ng-container>

      <!-- subject Column -->
      <ng-container matColumnDef="subject">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> sujet du message </th>
        <!-- <td mat-cell *matCellDef="let message" class="subject" (click)="onSubjectClick(message)">{{message.subject}}</td> -->
        <td mat-cell *matCellDef="let message" class="subject">
          <mat-form-field>
            <input
              [(ngModel)]="message.cleanSubject"
              (blur)="onEditComplete(message)"
              placeholder="Saisir le sujet"
              style="width: 100%;"
            />
          </mat-form-field>
        </td>
      </ng-container>

      <!-- To Column -->
      <ng-container matColumnDef="to">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Pour </th>
        <td mat-cell *matCellDef="let message" class="to">{{message.to.prenom}} {{message.to.nom}}</td>
      </ng-container>

      <!-- Document type Column -->
      <ng-container matColumnDef="documentType">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type CDA </th>
        <td mat-cell *matCellDef="let message" class="documentType"> {{ message.cdaMetadata?.type?.displayName }} </td>
      </ng-container>

      <!-- Received Date Column -->
      <ng-container matColumnDef="receivedDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Date de reception </th>
        <td mat-cell *matCellDef="let message" class="receivedDate"> {{ getReadableDate(message.receivedDate) }} </td>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="patient">
        <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: left;"> Patient </th>
        <td mat-cell *matCellDef="let message" style="vertical-align: middle; text-align: center;padding:5px;display: flex;justify-content: space-evenly;" class="selectPatient">
          <div style="margin-bottom: 5px;display: flex;align-items:center;">
            <span class="patient-label" *ngIf="message.patient">
              {{ message.patient ? message.patient.prenom + ' ' + message.patient.nom : '' }}
            </span>
            <!-- <input *ngIf="message.patient" [value]="message.patient ? message.patient.prenom + ' ' + message.patient.nom : ''" (ngModelOptions)="{standalone: true}" type="text" readonly="disabled"> -->
            <span class="patient-label" *ngIf="!message.patient && message.patientIdentiteRecuperee">
              {{ message.patientIdentiteRecuperee ? message.patientIdentiteRecuperee.prenom + ' ' + message.patientIdentiteRecuperee.nom : '' }}
            </span>
            <!-- <input *ngIf="!message.patient && message.patientIdentiteRecuperee" [value]="message.patientIdentiteRecuperee ? message.patientIdentiteRecuperee.prenom + ' ' + message.patientIdentiteRecuperee.nom : ''" (ngModelOptions)="{standalone: true}" type="text" readonly="disabled"> -->
            <span class="patient-label" *ngIf="!message.patient && !message.patientIdentiteRecuperee && message.patientIdentiteValidee">
              {{ message.patientIdentiteValidee ? message.patientIdentiteValidee.prenom + ' ' + message.patientIdentiteValidee.nom : '' }}
            </span>
            <!-- <input *ngIf="!message.patient && !message.patientIdentiteRecuperee && message.patientIdentiteValidee" [value]="message.patientIdentiteValidee ? message.patientIdentiteValidee.prenom + ' ' + message.patientIdentiteValidee.nom : ''" (ngModelOptions)="{standalone: true}" type="text" readonly="disabled"> -->
            <span class="patient-label" *ngIf="!message.patient && !message.patientIdentiteRecuperee && !message.patientIdentiteValidee && message.patientIdentiteProvisoire">
              {{ message.patientIdentiteProvisoire ? message.patientIdentiteProvisoire.prenom + ' ' + message.patientIdentiteProvisoire.nom : '' }}
            </span>
            <!-- <input *ngIf="!message.patient && !message.patientIdentiteRecuperee && !message.patientIdentiteValidee && message.patientIdentiteProvisoire" [value]="message.patientIdentiteProvisoire ? message.patientIdentiteProvisoire.prenom + ' ' + message.patientIdentiteProvisoire.nom : ''" (ngModelOptions)="{standalone: true}" type="text" readonly="disabled"> -->
            <!-- <input *ngIf="!message.patient && !message.patientIdentiteRecuperee && !message.patientIdentiteValidee && !message.patientIdentiteProvisoire" [value]="''" (ngModelOptions)="{standalone: true}" type="text" readonly="disabled"> -->
            <!-- <frg-button *ngIf="!message.patient && !message.patientIdentiteRecuperee && !message.patientIdentiteProvisoire && !message.patientIdentiteValidee && !message.patientIdentiteQualifie" (activated)="findPatient(message)">
              <div class="search-icon"></div>
            </frg-button> -->
            <button class="custom-delete-button" *ngIf="!message.patient && !message.patientIdentiteRecuperee && !message.patientIdentiteProvisoire && !message.patientIdentiteValidee && !message.patientIdentiteQualifie"
             (click)="findPatient(message)" title="Rechercher le patient à associer">
              <mat-icon>search</mat-icon>
            </button>
            <button class="custom-delete-button" *ngIf="(message.patient && message.manuallyAdded) || message.patientIdentiteValidee || message.patientIdentiteProvisoire"
             (click)="deletePatient(message)" title="Supprimer le lien avec le patient">
              <mat-icon>close</mat-icon>
            </button>
            <!-- <frg-button *ngIf="message.unknownPatientInfos && !message.patient" (activated)="createPatientFromMessage(message)" title="Créer un patient à partir de l'identité du patient trouvée dans le document">
              <div class="create-patient-icon"></div>
            </frg-button> -->
            <button class="custom-delete-button" *ngIf="message.unknownPatientInfos && !message.patient" (click)="createPatientFromMessage(message)" title="Créer un patient à partir de l'identité du patient trouvée dans le document">
              <mat-icon>person_add</mat-icon>
            </button>
            <frg-button *ngIf="this.Certification_Mode" (activated)="updatePatientInsFromMessage(message)" title="Mettre à jour l'INS du patient avec l'INS de l'identité trouvée dans le document">
              <div class="update-patient-icon"></div>
            </frg-button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="typeConsult">
        <th mat-header-cell *matHeaderCellDef> Type consultation</th>
        <td mat-cell *matCellDef="let message" style="text-align: center;" class="typeConsult">
          <select class="typeConsult-select" [(ngModel)]="message.typeConsult" name="typeConsultation">
            <option *ngFor="let option of refTypeConsultation" [value]="option.id">
              {{ option.libelle }}
            </option>
          </select>
        </td>
      </ng-container>

      <ng-container matColumnDef="qualifier">
        <th mat-header-cell *matHeaderCellDef> Qualifier</th>
        <td mat-cell *matCellDef="let message" style="text-align: center;" class="colqualifier">
          <label *ngIf="message.patientIdentiteRecuperee" title="Qualifier cette identité (Carte d'identité vérifiée)">
            <input
              [(ngModel)]="message.qualifierIdentity"
              type="checkbox" />
            <span class="checkMark"></span>
          </label>
        </td>
      </ng-container>

      <ng-container matColumnDef="traiter">
        <th mat-header-cell *matHeaderCellDef> Integrer</th>
        <td mat-cell *matCellDef="let message" style="text-align: center;" class="coltraiter">
          <label [title]="!message.manuallyAdded ? 'Associer un patient pour activer' : ''">
            <input id="actif"
              [checked]="message.traiter"
              (click)="handleTraiter(e, message)"
              type="checkbox" />
            <span class="checkMark"></span>
          </label>
                    <!-- [checked]="selection.isSelected(row)"> -->
        </td>
      </ng-container>

      <ng-container matColumnDef="supprimer">
        <th mat-header-cell *matHeaderCellDef> Supprimer</th>
        <td mat-cell *matCellDef="let message" style="text-align: center;" class="colsupprimer">
          <label>
            <input id="actif"
              [checked]="message.supprimer"
              (click)="handleSupprimer(e, message)"
              type="checkbox" />
            <span class="checkMark"></span>
          </label>
                    <!-- [checked]="selection.isSelected(row)"> -->
        </td>
      </ng-container>

      <ng-container matColumnDef="details">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let message" class="details">
          <button style="background-color: transparent;" mat-icon-button aria-label="expand row" (click)="toggleMessage(message); $event.stopPropagation()">
            <mat-icon *ngIf="expandedMessage !== message">keyboard_arrow_down</mat-icon>
            <mat-icon *ngIf="expandedMessage === message" >keyboard_arrow_up</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="cr-bio">
        <th mat-header-cell *matHeaderCellDef> Aperçu </th>
        <td mat-cell *matCellDef="let message" class="cr-bio">
          <frg-button *ngIf="message.isCrBio" [ngClass]="{'is-error-cr': message.hasErrorInCR && !message.hasCritiquesErrorInCR, 'is-critical-error-cr': message.hasCritiquesErrorInCR }" (activated)="displayCrBio(message)">
            <div class="btn-container" *ngIf="!message.hasErrorInCR && !message.hasCritiquesErrorInCR">
              <div class="icon eye-white"></div><div>CR Bio</div>
            </div>
            <div class="btn-container" *ngIf="message.hasErrorInCR || message.hasCritiquesErrorInCR">
              <div class="icon warning-white"></div><div>CR Bio</div>
            </div>
          </frg-button>
        </td>
      </ng-container>

      <ng-container matColumnDef="is-read">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let message" class="cr-bio">
          <span *ngIf="message.isRead">Lu</span>
          <span *ngIf="!message.isRead">Non lu</span>
        </td>
      </ng-container>

      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <ng-container matColumnDef="expandedDetail">
        <td mat-cell *matCellDef="let message" [attr.colspan]="displayedColumns.length">
          <div class="message-detail"
              [@detailExpand]="expandedMessage && message.id == expandedMessage.id ? 'expanded' : 'collapsed'">

              <ng-container *ngIf="expandedMessage?.isLoading">
                <div class="loader-wrapper">
                  <div class="lds-spinner">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="!expandedMessage?.isLoading">
                <div class="hors-limite-critique-wrapper" *ngIf="message.horsLimitesCritiquesValues && message.horsLimitesCritiquesValues.length > 0">
                  <div class="cda-meta-sub">Valeurs critiques</div>
                  <div class="valeurs-wrapper">
                    <div *ngFor="let limite of message.horsLimitesCritiquesValues">- {{ limite.ligne }} : <span class="accent">{{ limite.value }}</span> {{ limite.limite }}</div>
                  </div>

                  <div class="separator"></div>
                </div>

                <div class="hors-limite-wrapper" *ngIf="message.horsLimitesValues && message.horsLimitesValues.length > 0">
                  <div class="cda-meta-sub">Valeurs à surveiller</div>
                  <div class="valeurs-wrapper">
                    <div *ngFor="let limite of message.horsLimitesValues">- {{ limite.ligne }} : <span class="accent">{{ limite.value }}</span> {{ limite.limite }}</div>
                  </div>

                  <div class="separator"></div>
                </div>

                <ng-container *ngIf="message.cdaMetadata">
                  <ng-container *ngTemplateOutlet="cdaMetadataTemplate;context:message"></ng-container>
                </ng-container>
                <div class="message-part">
                  <div class="title">Titre :</div>
                  {{ message.subject }}
                </div>
                <div class="message-part">
                  <div class="title">Message :</div>
                  <div class="message-content">{{ message.content }}</div>
                </div>
                <div class="message-part" *ngIf="message.documents && message.documents.length > 0">
                  <div class="title">Documents :</div>
                  <div *ngFor="let document of message.documents;">
                    <a (click)="downloadDocument(document, message)">{{document.fileName}}</a> - {{getReadableSize(document.weight)}}
                  </div>
                </div>

                <div class="cda-version-wrapper" *ngIf="message.documentCdaVersions && message.documentCdaVersions.length > 0">
                  <div class="separator"></div>

                  <div class="cda-meta-sub">Versions antérieurs de ce document</div>
                  <div class="versions-wrapper">
                    <span *ngFor="let version of message.documentCdaVersions">Version {{ version.version }} ({{ version.updatedAt ? version.updatedAt : version.deletedAt ? version.deletedAt : 'Date de modification ou suppression inconnue' }})</span>
                  </div>
                </div>
              </ng-container>

          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="header"></tr>
      <!-- <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr> -->
      <tr mat-row *matRowDef="let message; columns: displayedColumns;"
          class="message-row"
          [class.message-expanded-row]="expandedMessage === message"
          [class.traiter]="message.traiter && message.patient"
          [class.supprimer]="message.supprimer">
      </tr>
      <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-message-row"></tr>

    </table>
    <mat-paginator #paginator [pageSizeOptions]="[10, 20, 40]" [length]="paginatorLength" aria-label="Selectionner les pages des courriers" showFirstLastButtons></mat-paginator>

    <!-- LEGENDE DES COULEURS -->
    <div class="tooltip-content" *ngIf="isTooltipVisible">
      <h3>Légende</h3>
      <div class="code-couleur-wrapper">
        <div class="code-couleur-row">
          <div class="code-couleur">
            <div class="hors-domaine-confiance">
              John Doe &lt;john.doe&#64;domaineInconnu.sante.com&gt;
            </div>
            <div class="label">Expediteur hors du domaine d'identification du cabinet sans contrat de confiance (Adresse de MSS non présente dans un correspondant du cabinet)</div>
          </div>
        </div>
      </div>
      <table class="code-couleur-table">
            <td class="code-couleur-table-col">
                <!-- Colonne 1 -->
                <table class="code-couleur-table-col">
                    <tr class="code-couleur-table-row">
                        <td class="couleur selected-status-inconnu"></td>
                        <td class="label">Patient inconnu</td>
                    </tr>
                    <tr class="code-couleur-table-row">
                        <td class="couleur selected-status-provisoire"></td>
                        <td class="label">Patient connu (identité provisoire)</td>
                    </tr>
                    <tr class="code-couleur-table-row">
                      <td class="couleur selected-status-provisoire"></td>
                        <td class="label">Patient connu (identité provisoire)</td>
                    </tr>
                    <tr class="code-couleur-table-row">
                      <td class="couleur selected-status-recupere"></td>
                        <td class="label">Patient connu (identité récupérée)</td>
                    </tr>
                    <tr class="code-couleur-table-row">
                      <td class="couleur selected-status-valide"></td>
                        <td class="label">Patient connu (identité validée)</td>
                    </tr>
                    <tr class="code-couleur-table-row">
                      <td class="couleur selected"></td>
                        <td class="label">Patient connu (identité qualifiée)</td>
                    </tr>
                    <tr class="code-couleur-table-row">
                      <td class="couleur ins-ok"></td>
                        <td class="label">INS valide (au moment de la relève)</td>
                    </tr>
                    <tr class="code-couleur-table-row">
                      <td class="couleur ins-ko"></td>
                        <td class="label">INS non valide (au moment de la relève)</td>
                    </tr>
                </table>
            </td>

            <td class="code-couleur-table-col">
                <!-- Colonne 2 -->
                <table class="code-couleur-table-col">
                    <tr class="code-couleur-table-row">
                        <td>
                            <frg-button>
                                <div class="btn-container">
                                    <div class="icon eye-white"></div><div>CR Bio</div>
                                </div>
                            </frg-button>
                        </td>
                        <td class="label">Résultats CR normaux</td>
                    </tr>
                    <tr class="code-couleur-table-row">
                        <td>
                            <frg-button class="is-error-cr">
                                <div class="btn-container">
                                    <div class="icon warning-white"></div><div>CR Bio</div>
                                </div>
                            </frg-button>
                        </td>
                        <td class="label">Résultats CR anormaux</td>
                    </tr>
                    <tr class="code-couleur-table-row">
                        <td>
                            <frg-button class="is-critical-error-cr">
                                <div class="btn-container">
                                    <div class="icon warning-white"></div><div>CR Bio</div>
                                </div>
                            </frg-button>
                        </td>
                        <td class="label">Résultats CR critiques</td>
                    </tr>
                </table>
            </td>
      </table>
    </div>

    <ng-template #cdaMetadataTemplate let-cdaMetadata="cdaMetadata">
      <div class="cda-meta-sub">Informations du document</div>
      <ng-container *ngIf="cdaMetadata && cdaMetadata.title">
        <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Titre document', value: cdaMetadata.title }"></ng-container>
      </ng-container>

      <ng-container *ngIf="cdaMetadata && cdaMetadata.version">
        <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Version document', value: cdaMetadata.version }"></ng-container>
      </ng-container>

      <ng-container *ngIf="cdaMetadata && cdaMetadata.datetime">
        <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Date document', value: getDateFormatted(cdaMetadata.datetime) }"></ng-container>
      </ng-container>

      <ng-container *ngIf="cdaMetadata && cdaMetadata.patient">
        <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Patient du document', value: cdaMetadata.patient }"></ng-container>
      </ng-container>

      <ng-container *ngIf="cdaMetadata && cdaMetadata.psAuthor">
        <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Auteur du document', value: cdaMetadata.psAuthor }"></ng-container>
      </ng-container>

      <ng-container *ngIf="cdaMetadata && cdaMetadata.psAuthorSpeciality">
        <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Spécialité de l\'auteur du document', value: cdaMetadata.psAuthorSpeciality }"></ng-container>
      </ng-container>

      <ng-container *ngIf="cdaMetadata && cdaMetadata.instPsAuthor">
        <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Institution de l\'auteur document', value: cdaMetadata.instPsAuthor }"></ng-container>
      </ng-container>

      <ng-container *ngIf="cdaMetadata && cdaMetadata.acts && cdaMetadata && cdaMetadata.acts.length > 0">
        <div class="cda-meta-sub">Actes</div>
        <ng-container *ngFor="let act of cdaMetadata && cdaMetadata.acts">
          <ng-container *ngIf="act.act">
            <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Acte', value: act.act }"></ng-container>
          </ng-container>
          <ng-container *ngIf="act.dateStartAct">
            <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Date début acte', value: getDateFormatted(act.dateStartAct) }"></ng-container>
          </ng-container>
          <ng-container *ngIf="act.dateEndAct">
            <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Date fin acte', value: getDateFormatted(act.dateEndAct) }"></ng-container>
          </ng-container>
          <ng-container *ngIf="act.performer && act.performer.assignedPerson">
            <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Participant', value: act.performer.assignedPerson }"></ng-container>
          </ng-container>
          <ng-container *ngIf="act.performer && act.performer.representedOrganization">
            <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Institut participant', value: act.performer.representedOrganization }"></ng-container>
          </ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="cdaMetadata && cdaMetadata.priseEnCharge && cdaMetadata.priseEnCharge && isObjectEmpty(cdaMetadata.priseEnCharge)">
        <div class="cda-meta-sub">Prise en charge</div>
      </ng-container>

      <ng-container *ngIf="cdaMetadata && cdaMetadata.priseEnCharge && cdaMetadata.priseEnCharge.typeSortie">
        <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Type de sortie', value: cdaMetadata.priseEnCharge.typeSortie }"></ng-container>
      </ng-container>

      <ng-container *ngIf="cdaMetadata && cdaMetadata.priseEnCharge && cdaMetadata.priseEnCharge.responsable">
        <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Responsable', value: cdaMetadata.priseEnCharge.responsable }"></ng-container>
      </ng-container>

      <ng-container *ngIf="cdaMetadata && cdaMetadata.priseEnCharge && cdaMetadata.priseEnCharge.participants && cdaMetadata.priseEnCharge.participants.length > 0">
        <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Participants' }"></ng-container>
        <ng-container *ngFor="let participant of cdaMetadata.priseEnCharge.participants">
          <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ value: participant }"></ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="cdaMetadata && cdaMetadata.priseEnCharge && cdaMetadata.priseEnCharge.organization">
        <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Organisme', value: cdaMetadata.priseEnCharge.organization }"></ng-container>
      </ng-container>

      <ng-container *ngIf="cdaMetadata && cdaMetadata.priseEnCharge && cdaMetadata.priseEnCharge.location">
        <ng-container *ngTemplateOutlet="cdaMetadataInfoTemplate;context:{ label: 'Adresse', value: cdaMetadata.priseEnCharge.location }"></ng-container>
      </ng-container>

      <div class="separator"></div>
    </ng-template>
    <ng-template #cdaMetadataInfoTemplate let-label="label" let-value="value">
      <div class="message-part">
        <div *ngIf="label && label !== ''" class="title">{{ label }} :</div>
        <ng-container *ngIf="value">{{ value }}</ng-container>
      </div>
    </ng-template>




